/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var PropTypes = require("prop-types");
var Input_1 = require("./Input");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./InputShortCode.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var createArrayOfLength_1 = require("./util/createArrayOfLength");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-inputShortCode");
var InputShortCode = /** @class */ (function (_super) {
    tslib_1.__extends(InputShortCode, _super);
    function InputShortCode(props) {
        var _this = _super.call(this, props) || this;
        _this.inputElem = null;
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onPaste = _this.onPaste.bind(_this);
        return _this;
    }
    InputShortCode.prototype.onKeyDown = function (e) {
        var _a = this.props, onChange = _a.onChange, placeholder = _a.placeholder, _b = _a.fixedChars, fixedChars = _b === void 0 ? [] : _b, value = _a.value; // eslint-disable-line react/prop-types
        if (onChange) {
            if (e.keyCode === 8) {
                // Backspace
                if (e.altKey) {
                    onChange(e, "");
                }
                else {
                    var newValue = value.substr(0, value.length - 1);
                    if (placeholder && fixedChars.indexOf(newValue.length) >= 0) {
                        newValue = newValue.substr(0, newValue.length - 1);
                    }
                    onChange(e, newValue);
                }
            }
        }
    };
    InputShortCode.prototype.onChange = function (e) {
        var _a = this.props, value = _a.value, maxLength = _a.maxLength, placeholder = _a.placeholder, _b = _a.fixedChars, fixedChars = _b === void 0 ? [] : _b, onChange = _a.onChange; // eslint-disable-line react/prop-types
        if (onChange && e.target.value) {
            var limitedString = value.substr(0, maxLength - 1) + e.target.value.substr(0, 1);
            if (placeholder && fixedChars.indexOf(value.length + 1) >= 0) {
                limitedString += placeholder.charAt(value.length + 1);
            }
            onChange(e, limitedString);
        }
    };
    InputShortCode.prototype.onClick = function () {
        if (this.inputElem) {
            this.inputElem.focus();
            if (this.inputElem.value) {
                try {
                    this.inputElem.setSelectionRange(0, 1);
                }
                catch (error) {
                    // Silently fail, as this is a progressive enhancement
                }
            }
        }
    };
    InputShortCode.prototype.onPaste = function (e) {
        var _a = this.props, maxLength = _a.maxLength, onChange = _a.onChange; // eslint-disable-line react/prop-types
        try {
            // @ts-ignore
            var text = e.clipboardData.getData("Text");
            onChange && onChange(e, text.substr(0, maxLength));
        }
        catch (error) {
            // Silently fail, as this is a progressive enhancement
        }
        finally {
            e.preventDefault();
        }
    };
    InputShortCode.prototype.render = function () {
        var _this = this;
        var _a = this.props, maxLength = _a.maxLength, placeholder = _a.placeholder, props = tslib_1.__rest(_a, ["maxLength", "placeholder"]);
        return (React.createElement(Input_1.Input, tslib_1.__assign({ maxLength: maxLength, renderInput: function (_a) {
                var className = _a.className, value = _a.value, inputProps = tslib_1.__rest(_a, ["className", "value"]);
                return (React.createElement("div", { className: classnames(className, moduleClassName()), onClick: _this.onClick },
                    React.createElement("div", { className: moduleClassName("chars") }, createArrayOfLength_1.createArrayOfLength(maxLength).map(function (nada, index) {
                        if (value[index] && index !== maxLength - 1) {
                            return (React.createElement("span", { key: index, className: moduleClassName("char") }, value[index]));
                        }
                        if (index === value.length || value.length >= maxLength) {
                            return (React.createElement("input", tslib_1.__assign({ key: "input", className: moduleClassName("char") }, inputProps, { ref: function (elem) { return (_this.inputElem = elem); }, placeholder: placeholder ? placeholder.charAt(index) : " ", value: value.length >= maxLength ? value[maxLength - 1] : "", onPaste: _this.onPaste, onKeyDown: _this.onKeyDown, onChange: _this.onChange })));
                        }
                        return (React.createElement("span", { key: index, className: moduleClassName("char") }, placeholder ? placeholder.charAt(index) : undefined));
                    }))));
            } }, props)));
    };
    InputShortCode.propTypes = tslib_1.__assign({}, Input_1.Input.propTypes, { fixedChars: PropTypes.arrayOf(PropTypes.number), maxLength: PropTypes.number.isRequired });
    InputShortCode.defaultProps = tslib_1.__assign({}, Input_1.Input.defaultProps);
    return InputShortCode;
}(React.Component));
exports.InputShortCode = InputShortCode;